
import { useState } from "react";
import { useProfile } from "@/hooks/useProfile";
import { GymList } from "./gym-code/GymList";
import { JoinGymForm } from "./gym-code/JoinGymForm";
import { CurrentGym } from "./gym-code/CurrentGym";
import { useGymQueries } from "@/hooks/gym/useGymQueries";
import { useGymActions } from "@/hooks/gym/useGymActions";

export const GymCodeForm = () => {
  const [code, setCode] = useState("");
  const { profile, updateProfile } = useProfile();
  const { userGyms, currentGym } = useGymQueries(profile);
  const { isLoading, joinGym, leaveGym } = useGymActions(profile, updateProfile);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await joinGym(code);
    if (success) {
      setCode("");
    }
  };

  const handleLeaveGym = async (gymId?: string) => {
    const success = await leaveGym(gymId);
    // No need to do anything else, the hook handles cache invalidation
    console.log("Leave gym result:", success);
  };

  // Todos los usuarios pueden tener múltiples gimnasios
  if (userGyms && userGyms.length > 0) {
    return (
      <div className="space-y-6">
        <div className="gym-list-section">
          <GymList 
            userGyms={userGyms} 
            onLeaveGym={handleLeaveGym} 
            currentGymId={profile.gym_id || undefined}
          />
        </div>
        <div className="join-gym-section">
          <JoinGymForm
            code={code}
            isLoading={isLoading}
            onChange={setCode}
            onSubmit={handleSubmit}
            label="Unirse a otro gimnasio"
          />
        </div>
      </div>
    );
  }

  // Para usuarios con gimnasio principal pero sin membresías activas
  if (profile.gym_id && currentGym && (!userGyms || userGyms.length === 0)) {
    return (
      <CurrentGym
        gymName={currentGym.name}
        onLeaveGym={handleLeaveGym}
        showLeaveButton={profile.role === "socio" || profile.role === "profesor" || profile.role === "manager"}
      />
    );
  }

  // Para usuarios sin gimnasio
  return (
    <div className="no-gym-section">
      <JoinGymForm
        code={code}
        isLoading={isLoading}
        onChange={setCode}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
